import React from "react";
import { Card, Figure, Container } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  Pagination, Grid, Navigation, Mousewheel
} from "swiper";
import {
  professionalChefs, pcTitle, pcCard, titlePosition,
  pcCardImg, chefTitle, position, pcCardBody, learnMore,
  lmText, lmFigure, pcCardBodyContent, sliderArrows, prevIcon, nextIcon
} from "./style.mod.scss";
import locale from "locales";
import Link from "components/link";
import { ChevronLeft, ChevronRight } from "react-bootstrap-icons";
import getImagePath from "helpers/get-image-path";
import Right from "assets/images/icons/right.png";

const ProfessionalChefs = ({ data }) => {

  const { ambassador, title } = data;
  const ambassadorLength = (ambassador.length <= 4) ? 1 : 2;
  const settings = {
    speed: 500,
    grid: { rows: 1 },
    modules: [Pagination, Grid, Navigation, Mousewheel],
    className: "ambassadors",
    slidesPerView: 1,
    mousewheel: {
      enabled: true,
      forceToAxis: true,
    },
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
      clickable: true
    },
    breakpoints: {
      767: {
        slidesPerView: 2,
        pagination: false,
        grid: { rows: ambassadorLength },
      },
      992: {
        slidesPerView: 3,
        grid: { rows: ambassadorLength },
      },
      1025: {
        slidesPerView: 4,
        grid: { rows: ambassadorLength },
      },
      1270: {
        slidesPerView: 4,
        grid: { rows: ambassadorLength },
      }
    },
  };

  return (
    <div className={professionalChefs} style={{ backgroundColor: data.bgColor && data.bgColor.hex }}>
      <Container>
        <h2 className={pcTitle}>{title}</h2>
        <Swiper  {...settings}>
          {ambassador.map((chef) => (
            <SwiperSlide key={chef._key}>
              <Link to={chef.link}>
                <Card className={pcCard}>
                  <Card.Img className={pcCardImg} srcSet={getImagePath(chef?.image, true)} alt={chef.image?.alt} />
                  <Card.Body className={pcCardBody}>
                    <div className={pcCardBodyContent}>
                      <div className={titlePosition}>
                        <h3 className={chefTitle}>{chef.name}</h3>
                        <p className={position}>{chef.position?.length < 20 ? chef.position : chef.position?.substring(0, 30) + "..."}</p>
                      </div>
                      <div className={learnMore}>
                        <h5 className={lmText}>{locale.pages.cooks.learnMore}</h5>
                        <Figure className={lmFigure}>
                          <Figure.Image
                            width={7}
                            height={10}
                            alt="Right chevron"
                            src={Right}
                          />
                        </Figure>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>
        <div className={sliderArrows}>
          <button className="swiper-button-prev">
            <span className={prevIcon}><ChevronLeft /></span>
          </button>
          <button className="swiper-button-next">
            <span className={nextIcon}><ChevronRight /></span>
          </button>
        </div>
      </Container>
    </div>
  );
};

export default ProfessionalChefs;
